import type {
  TicketEventResultsDto,
  TicketEventStatisticsDto,
} from '@/domain/my-bets-live';
import { api } from './client';
import { endpoints } from './endpoints';

/**
 * Seed My Bets inline stats when a ticket expands.
 * TEMP: classic SportsAPI `api/front/events/results` (form `EventIds`) until
 * SportsAPI2 ships `api/v1/front/events/results`.
 */
export function fetchEventResults(
  eventIds: readonly number[],
  signal?: AbortSignal,
): Promise<TicketEventResultsDto[]> {
  if (eventIds.length === 0) return Promise.resolve([]);
  return api.post<TicketEventResultsDto[]>(
    endpoints.sports.eventResults.host,
    endpoints.sports.eventResults.path,
    { EventIds: [...eventIds] } as unknown as Record<string, unknown>,
    signal,
  );
}

/**
 * Refresh live period / score / cards for open My Bets stats widgets.
 * TEMP: classic SportsAPI `api/betting/statistics` until SportsAPI2 ships
 * `api/v1/betting/statistics`.
 */
export function fetchTicketEventStatistics(
  eventIds: readonly number[],
  signal?: AbortSignal,
): Promise<TicketEventStatisticsDto[]> {
  if (eventIds.length === 0) return Promise.resolve([]);
  return api.post<TicketEventStatisticsDto[]>(
    endpoints.betting.statistics.host,
    endpoints.betting.statistics.path,
    { EventIds: [...eventIds] } as unknown as Record<string, unknown>,
    signal,
  );
}
